module.exports = {
  request: function(req, token) {
    // console.log("Setting authorization header to:");
    // console.log('Authorization: Bearer ' + token);
    this.options.http._setHeaders.call(this, req, {
      Authorization: "Bearer " + token
    });
  },

  response: function(res) {
    // console.log("Response:");
    // console.log(res);
    // console.log("Got access token: " + res.data.access_token);
    if (!!res.data.access_token) {
      return res.data.access_token;
    }

    return null;
  }
};
